import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const StatisticsByReactivationActions = {
    searchData(params, callback) {
        dispatch({
            type  : AppConstants.STATISTICS_SEARCH_START_LOADING,
            params
        });

        api.getReportByReactivation(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.STATISTICS_SEARCH_SUCCESS,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.STATISTICS_SEARCH_FAIL,
                        error: err
                    });
                });
            });
    }
};

export default StatisticsByReactivationActions;
